<template>
  <scoped>
    <VerticalNavigator>
      <h1>
        Page Not Found
      </h1>
      <p>
        Server could not find requested page.
      </p>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
</script>
